import {
  CenterPos,
  DetailsButton,
  DetailsItem,
  DetailsItems,
  DetailsText,
  HistoryRow,
  ItemRow,
  ResultsColumn,
  Row,
  TitleTextLight,
  TitleWrapper,
} from './DTRbiHockeyChallengeWidget.styles';
import React from 'react';
import { COLUMN_WIDTH } from './GameHistory';
import { NODATA } from './DTRbiHockeyChallengeWidget';

export const GameHistoryItem = ({
  history,
  contestDate,
  picks,
  offers,
  challengeId,
  streak,
  challengeWeek,
  selectedChallengeId,
  handleChangeSelectedChallengeId,
  points,
}) => {
  const isChallengeOpen = challengeId === selectedChallengeId;
  const detailsAvailable = history.length > 0;
  const picksData = picks.length === 0 ? NODATA : picks.map((pick) => pick.playerName).join(', ');
  let prizeEarned;

  if (points !== null && points === 0) {
    if (offers.length > 0) {
      prizeEarned = offers.map((offer) => offer.prize).join(', ');
    } else {
      prizeEarned = NODATA;
    }
  } else if (points !== null && points !== undefined) {
    prizeEarned = `${points} points`;
  } else if (offers.length > 0) {
    prizeEarned = offers.map((offer) => offer.prize).join(', ');
  } else {
    prizeEarned = NODATA;
  }

  const toggleSelectedChallengeId = () => {
    handleChangeSelectedChallengeId(challengeId);
  };

  return (
    <>
      <Row open={isChallengeOpen}>
        <ResultsColumn $width={COLUMN_WIDTH.date}>{contestDate}</ResultsColumn>
        <ResultsColumn $width={COLUMN_WIDTH.picks}>
          <TitleWrapper>{picksData}</TitleWrapper>
        </ResultsColumn>
        <ResultsColumn $width={COLUMN_WIDTH.prize}>{prizeEarned}</ResultsColumn>
        <ResultsColumn $width={COLUMN_WIDTH.streak} $justifyContent={'center'}>
          {streak ? streak : NODATA}
        </ResultsColumn>
        <ResultsColumn $width={COLUMN_WIDTH.challenge}>{challengeWeek ? challengeWeek.title : NODATA}</ResultsColumn>
        <ResultsColumn $width={COLUMN_WIDTH.details}>
          <CenterPos>
            {detailsAvailable ? (
              <DetailsButton
                open={isChallengeOpen}
                onClick={() => toggleSelectedChallengeId()}
                data-testID={'details-btn'}
              />
            ) : (
              NODATA
            )}
          </CenterPos>
        </ResultsColumn>
      </Row>
      {isChallengeOpen && detailsAvailable && (
        <HistoryRow data-testID={'details-list'}>
          <ItemRow>
            <ResultsColumn $width={COLUMN_WIDTH.date} />
            <ResultsColumn $width={'45%'}>
              <DetailsItems>
                {picks.map((pick) => (
                  <DetailsItem>
                    <DetailsText key={pick.setId}>
                      {pick.playerName} <TitleTextLight>{pick.correct ? '(scored)' : '(didn’t score)'}</TitleTextLight>
                    </DetailsText>
                  </DetailsItem>
                ))}
              </DetailsItems>
            </ResultsColumn>
            <ResultsColumn $width={'35%'}>
              <DetailsItems>
                <DetailsItem>
                  <DetailsText>{challengeWeek ? challengeWeek.title : NODATA}</DetailsText>
                  <DetailsText>
                    <TitleTextLight>Starting:</TitleTextLight>{' '}
                    {challengeWeek ? challengeWeek.startDate.toLocaleDateString() : NODATA}
                  </DetailsText>
                  <DetailsText>
                    <TitleTextLight>Status:</TitleTextLight> {challengeWeek ? challengeWeek.status : NODATA}
                  </DetailsText>
                </DetailsItem>
              </DetailsItems>
            </ResultsColumn>
          </ItemRow>
        </HistoryRow>
      )}
    </>
  );
};
